(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tora-concept-header"]) return;
  try {
    
  if (!customElements.get('tora-concept-header')) {
    customElements.define(
      'tora-concept-header',
      class ToraConceptHeader extends HTMLElement {
        connectedCallback() {
          this.desktopDropdown = this.querySelector('[data-desktop-dropdown]');
          this.desktopTabs = Array.from(this.querySelectorAll('[data-desktop-tab]'));
          this.desktopPanels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
          this.mobileDialog = this.querySelector('[data-mobile-dialog]');
          this.mobileOpen = this.querySelector('[data-mobile-open]');
          this.mobileClose = this.querySelector('[data-mobile-close]');
          this.mobileTabs = Array.from(this.querySelectorAll('[data-mobile-tab]'));
          this.mobilePanels = Array.from(this.querySelectorAll('[data-mobile-panel]'));
          this.savedOverflow = '';
          this.activeDesktopPanel = null;

          this.updatePosition = this.updatePosition.bind(this);
          this.closeDesktop = this.closeDesktop.bind(this);
          this.closeMobile = this.closeMobile.bind(this);

          this.desktopTabs.forEach((button) => {
            button.addEventListener('mouseenter', () => this.openDesktop(button.dataset.desktopTab));
            button.addEventListener('click', () => {
              if (this.activeDesktopPanel === button.dataset.desktopTab) this.closeDesktop();
              else this.openDesktop(button.dataset.desktopTab);
            });
            button.addEventListener('keydown', (event) => {
              if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey && this.activeDesktopPanel === button.dataset.desktopTab)) {
                this.openDesktop(button.dataset.desktopTab);
                const panel = this.desktopPanels.find((item) => item.dataset.desktopPanel === button.dataset.desktopTab);
                const first = panel?.querySelector('a[href], button:not([disabled])');
                if (first) { event.preventDefault(); first.focus(); }
              }
            });
          });

          this.querySelector('.tora-nav__desktop')?.addEventListener('mouseleave', () => {
            if (!this.querySelector('.tora-nav__desktop')?.contains(document.activeElement)) this.closeDesktop();
          });
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.activeDesktopPanel) {
              const trigger = this.desktopTabs.find((button) => button.dataset.desktopTab === this.activeDesktopPanel);
              this.closeDesktop();
              trigger?.focus();
              event.preventDefault();
            }
          });
          this.desktopPanels.forEach((panel) => {
            panel.addEventListener('keydown', (event) => {
              if (event.key !== 'Tab') return;
              const links = Array.from(panel.querySelectorAll('a[href], button:not([disabled])'));
              const index = this.desktopTabs.findIndex((button) => button.dataset.desktopTab === panel.dataset.desktopPanel);
              if (event.shiftKey && event.target === links[0]) {
                event.preventDefault();
                this.desktopTabs[index]?.focus();
              } else if (!event.shiftKey && event.target === links[links.length - 1] && this.desktopTabs[index + 1]) {
                event.preventDefault();
                this.closeDesktop();
                this.desktopTabs[index + 1].focus();
              }
            });
          });
          this.addEventListener('focusout', () => {
            requestAnimationFrame(() => {
              if (!this.querySelector('.tora-nav__desktop')?.contains(document.activeElement)) this.closeDesktop();
            });
          });
          this.mobileOpen?.addEventListener('click', () => this.openMobile());
          this.mobileClose?.addEventListener('click', this.closeMobile);
          this.mobileDialog?.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.closeMobile();
          });
          this.mobileDialog?.addEventListener('click', (event) => {
            if (event.target === this.mobileDialog) this.closeMobile();
          });
          this.mobileDialog?.querySelectorAll('a').forEach((link) => link.addEventListener('click', this.closeMobile));
          this.mobileTabs.forEach((button) => button.addEventListener('click', () => this.activateMobile(button.dataset.mobileTab)));

          window.addEventListener('scroll', this.updatePosition, { passive: true });
          window.addEventListener('resize', this.updatePosition, { passive: true });
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) this.closeDesktop();
          });
          this.updatePosition();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.updatePosition);
          window.removeEventListener('resize', this.updatePosition);
        }

        updatePosition() {
          const announcement = document.querySelector('.announcement-bar-section');
          const announcementHeight = announcement ? announcement.offsetHeight : 0;
          const scrolled = window.scrollY > 36;
          const tight = !this.classList.contains('tora-nav--offers') && window.matchMedia('(max-width: 960px)').matches;
          const gap = tight ? 4 : 8;
          const top = scrolled ? 8 : announcementHeight + gap;
          this.style.setProperty('--tora-header-top', `${top}px`);
          this.classList.toggle('is-scrolled', scrolled);
          document.documentElement.style.setProperty('--tora-announcement-height', `${announcementHeight}px`);
        }

        openDesktop(panelName) {
          if (!this.desktopDropdown) return;
          this.activeDesktopPanel = panelName;
          this.desktopDropdown.hidden = false;
          this.desktopPanels.forEach((panel) => {
            panel.hidden = panel.dataset.desktopPanel !== panelName;
          });
          this.desktopTabs.forEach((button) => {
            const active = button.dataset.desktopTab === panelName;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-expanded', String(active));
          });
        }

        closeDesktop() {
          this.activeDesktopPanel = null;
          if (this.desktopDropdown) this.desktopDropdown.hidden = true;
          this.desktopTabs.forEach((button) => {
            button.classList.remove('is-active');
            button.setAttribute('aria-expanded', 'false');
          });
        }

        activateMobile(panelName) {
          this.mobileTabs.forEach((button) => button.setAttribute('aria-selected', String(button.dataset.mobileTab === panelName)));
          this.mobilePanels.forEach((panel) => {
            panel.hidden = panel.dataset.mobilePanel !== panelName;
          });
        }

        openMobile() {
          if (!this.mobileDialog) return;
          this.activateMobile('shop');
          this.savedOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          if (typeof this.mobileDialog.showModal === 'function') this.mobileDialog.showModal();
          else this.mobileDialog.setAttribute('open', '');
          requestAnimationFrame(() => this.mobileClose?.focus());
        }

        closeMobile() {
          if (!this.mobileDialog?.hasAttribute('open')) return;
          if (typeof this.mobileDialog.close === 'function') this.mobileDialog.close();
          else this.mobileDialog.removeAttribute('open');
          document.body.style.overflow = this.savedOverflow;
          requestAnimationFrame(() => this.mobileOpen?.focus());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tora-matcha-finder"] && !Shopify.designMode) return;
  try {
    
  class ToraMatchaFinder {
    constructor(root) {
      this.root = root;
      this.quiz = root.querySelector('[data-finder-quiz]');
      this.steps = Array.from(root.querySelectorAll('[data-finder-step]'));
      this.segments = Array.from(root.querySelectorAll('[data-progress-segment]'));
      this.progressText = root.querySelector('[data-progress-text]');
      this.backButton = root.querySelector('[data-finder-back]');
      this.nextButton = root.querySelector('[data-finder-next]');
      this.result = root.querySelector('[data-finder-result]');
      this.resultProducts = Array.from(root.querySelectorAll('[data-result-product]'));
      this.restartButton = root.querySelector('[data-finder-restart]');
      this.currentStep = 0;

      this.root.querySelectorAll('.tora-finder__radio').forEach((input) => {
        input.addEventListener('change', () => {
          this.nextButton.disabled = false;
        });
      });

      this.backButton.addEventListener('click', () => this.showStep(this.currentStep - 1));
      this.nextButton.addEventListener('click', () => {
        if (this.currentStep === this.steps.length - 1) {
          this.showResult();
          return;
        }

        this.showStep(this.currentStep + 1);
      });
      this.restartButton.addEventListener('click', () => this.restart());
    }

    showStep(index) {
      this.currentStep = Math.max(0, Math.min(index, this.steps.length - 1));

      this.steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== this.currentStep;
      });

      this.segments.forEach((segment, segmentIndex) => {
        segment.classList.toggle('is-active', segmentIndex <= this.currentStep);
      });

      this.progressText.textContent =
        `${this.root.dataset.progressLabel} ${this.currentStep + 1} / ${this.steps.length}`;
      this.backButton.hidden = this.currentStep === 0;
      this.nextButton.textContent =
        this.currentStep === this.steps.length - 1
          ? this.root.dataset.resultLabel
          : this.root.dataset.nextLabel;

      const selected = this.steps[this.currentStep].querySelector('.tora-finder__radio:checked');
      this.nextButton.disabled = !selected;
      this.steps[this.currentStep].querySelector('.tora-finder__question').focus();
    }

    showResult() {
      const answers = this.steps
        .map((step) => step.querySelector('.tora-finder__radio:checked'))
        .filter(Boolean)
        .map((input) => input.value);
      const premiumScore = answers.filter((answer) => answer === 'premium').length;
      const baristaAvailable = this.root.dataset.baristaAvailable === 'true';
      let resultKey = premiumScore >= 2 ? 'premium' : 'barista';
      const usedFallback = resultKey === 'barista' && !baristaAvailable;
      if (usedFallback) resultKey = 'premium';

      this.resultProducts.forEach((product) => {
        product.hidden = product.dataset.resultProduct !== resultKey;
        if (product.dataset.resultProduct === 'premium') {
          const defaultText = product.querySelector('[data-result-text="default"]');
          const fallbackText = product.querySelector('[data-result-text="fallback"]');
          if (defaultText) defaultText.hidden = usedFallback;
          if (fallbackText) fallbackText.hidden = !usedFallback;
        }
      });

      this.quiz.hidden = true;
      this.result.hidden = false;
      this.result.focus();
    }

    restart() {
      this.root.querySelectorAll('.tora-finder__radio').forEach((input) => {
        input.checked = false;
      });
      this.result.hidden = true;
      this.quiz.hidden = false;
      this.showStep(0);
    }
  }

  const initializeToraMatchaFinders = (scope = document) => {
    scope.querySelectorAll('[data-tora-matcha-finder]').forEach((root) => {
      if (root.dataset.finderInitialized === 'true') return;
      root.dataset.finderInitialized = 'true';
      new ToraMatchaFinder(root);
    });
  };

  initializeToraMatchaFinders();
  document.addEventListener('shopify:section:load', (event) => {
    initializeToraMatchaFinders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
